import PaperBase from '../Paper/PaperBase'
import { Typography } from '@mui/material'

const LcElemensCards = ({ currentCurriculum, lcs = [], width = 'min-w-120px max-w-120px', classUlInfo }) => {
  return (
    < >
      {currentCurriculum?.lcElements?.children?.sort((a, b) => b.position - a.position)?.map((item, i) => (
        <div className={[
          "flex flex-nowrap w-full gap-1",
          i === 0 ?  'sticky z-10' : ''
        ].join(' ')} key={item._id}
        style={{
          bottom: classUlInfo ? '67px' : '32px'
        }}>
          <PaperBase 
            backgroundColor={item?.secondaryColor}
            color={item?.primaryColor}
            className={['font-bold sticky left-0 z-10', width].join(' ')}
            children={item?.name}
          />
          { lcs?.map((lc, index) => {
            return (
              <PaperBase
                key={`lc-elements-${item._id}-lc-${lc._id}-index-${index}`}
                backgroundColor={lc.lcElements?.[item._id] ? item?.secondaryColor : null}
                color={lc.lcElements?.[item._id] ? item?.primaryColor : null}
                className={[
                  'min-w-200px w-full text-ellipsis',
                  lc.lcElements?.[item._id] ? '' : 'bg-lines'
                ].join(' ')}
                children={<Typography className='text-ellipsis text-sm'>{lc.lcElements?.[item._id]}</Typography>}
              />
            )}
          )}
        </div>
      ))}
    </>
  )
}

export default LcElemensCards